import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
@Pipe({name: 'readableDuration'})
export class DurationPipe implements PipeTransform {
  transform(value: number): string {
    let d = moment.duration(parseInt(`${value}`), 'seconds');
    return d.humanize();
  }
}
